import * as React from 'react';
import { Component } from 'react';
import { Baseline } from './AnimatedBaseline.s';
import Typing from 'react-typing-animation';

const baselinePuchlines = [
  `refait ton weekend oklm`,
  `"te fera pas souffrir OKAY"`,
  `pousse mémé dans les orties`,
  `assure tes bails`,
  `casse trois pattes à un canard`,
  `passe crème`,
];

export class AnimatedBaseline extends Component<{}, {}> {
  render(): JSX.Element {
    return (
      <Baseline>
        Dix-huit secondes pour trouver l’expo <br /> qui&nbsp;
        <Typing loop={true}>
          {React.Children.toArray(
            baselinePuchlines.map(puchline => (
              <>
                <span>
                  <b>{puchline}</b>.
                </span>
                <Typing.Backspace delay={500} count={puchline.length + 1} />
              </>
            ))
          )}
        </Typing>
      </Baseline>
    );
  }
}



// WEBPACK FOOTER //
// src/app/src/components/AnimatedBaseline/AnimatedBaseline.tsx